module.exports = __webpack_public_path__ + "static/media/conf-app3.ea2d76d6.png";